import React from 'react';
type StarsProps = {
  count?: number;
  size?: number;
  className?: string;
};
export function Stars({
  count = 5,
  size = 14,
  className = ''
}: StarsProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} role="img" aria-label={`${count} de 5 estrellas`} data-id="element-146" data-mp="3kq4wcumwd5wm">
      {Array.from({
      length: 5
    }).map((_, i) => <svg key={i} aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill={i < count ? '#3E6B3B' : 'none'} stroke={i < count ? '#3E6B3B' : 'rgba(62,107,59,0.45)'} strokeWidth="1.5" data-id="element-147" data-mp="3pqsx480xh141" data-mpi={i}>
          <path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.2 6.5L12 17.3l-5.9 3.1 1.2-6.5L2.5 9.3l6.6-.9L12 2.5z" data-id="element-148" data-mp="3ggihtxor8ah" />
        </svg>)}
    </div>;
}